import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, CircularProgress, Typography } from '@mui/material';
import { Link, useSearchParams } from 'react-router-dom';
import { verifyEmail } from '../utils/api';


const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [state, setState] = useState({ loading: true, error: '' });

  useEffect(() => {
    let alive = true;
    if (!token) {
      setState({ loading: false, error: 'This verification link is invalid.' });
      return () => { alive = false; };
    }
    verifyEmail(token)
      .then(() => {
        if (alive) setState({ loading: false, error: '' });
      })
      .catch((error) => {
        if (alive) setState({ loading: false, error: error.data?.message || 'Email could not be verified.' });
      });
    return () => { alive = false; };
  }, [token]);

  return (
    <Box sx={{ minHeight: '100dvh', display: 'grid', placeItems: 'center', px: 2 }}>
      <Box sx={{ width: '100%', maxWidth: 520, p: 4, borderRadius: 4, border: '2px solid', borderColor: 'primary.main', bgcolor: '#121816', textAlign: 'center' }}>
        {state.loading ? (
          <CircularProgress />
        ) : state.error ? (
          <>
            <Typography variant="h3" sx={{ color: 'secondary.main', mb: 2 }}>Verification failed</Typography>
            <Alert severity="error" sx={{ mb: 2 }}>{state.error}</Alert>
            <Button component={Link} to="/profile" variant="contained">Open Profile</Button>
          </>
        ) : (
          <>
            <Typography variant="h3" sx={{ color: 'primary.main', mb: 2 }}>Email Verified</Typography>
            <Typography sx={{ mb: 3 }}>Your email address is confirmed.</Typography>
            <Button component={Link} to="/user-home" variant="contained">Continue to App</Button>
          </>
        )}
      </Box>
    </Box>
  );
};

export default VerifyEmail;
